import React, {useState, useEffect} from "react";


import './styles/result.scss';
import Active from '../img/active.svg'
import Unavailable from '../img/unavailable.svg'
import Close from '../img/sclose.png';
import Planned from '../img/clock.svg';


const DetailSection = (props) => {

    const data = props.data;
    let defTech;

    const [technologies, setTechnologies] = useState()

    useEffect(() => {
        defTech = (
            // eslint-disable-next-line
            <div className="grid">
                <div onClick={() => displayDetails("VDSL", "_BITSTREAM_NGA_VULA_FTTCab", "R")} className="grid__item" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', maxHeight: '100%'}}>
                    <img src={setIcon(data['COPERTURA_BITSTREAM_NGA_VULA_FTTCab'])} alt="" style={{width: '30%'}} />
                    <h3>VDSL</h3>
                </div>
                <div onClick={() => displayDetails("EVDSL", "_EVDSL_BITSTREAM_NGA_VULA_FTTCab","R")} className="grid__item" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <img src={setIcon(data["COPERTURA_EVDSL_BITSTREAM_NGA_VULA_FTTCab"])} alt="" style={{width: '30%'}} />
                    <h3>EVDSL</h3>
                </div>
                <div onClick={() => displayDetails("FTTH", "_BITSTREAM_NGA_VULA_FTTH")} className="grid__item" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <img src={setIcon(data['COPERTURA_BITSTREAM_NGA_VULA_FTTH'])} alt="" style={{width: '30%'}} />
                    <h3>FTTH</h3>
                </div>
                <div onClick={() => displayDetails("Fibra Dedicata", "_CIRCUITI_TERM_ETH_FIBRA_OTTICA", "FD")} className="grid__item" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <img src={setIcon(data['COPERTURA_CIRCUITI_TERM_ETH_FIBRA_OTTICA'])} alt="" style={{width: '30%'}} />
                    <h3>Fibra Dedicata</h3>
                </div>
            </div>
        )
        setTechnologies(defTech)
    }, [data])
    

    const setIcon = (status) => {
        if(status === 'Pianificato' ) return Planned;
        else if(status !== 'Attivo' && status !== 'SI') return Unavailable;
        else return Active;
    }
    
    const setPrevDate = (status) => {
        if(status !== 'Pianificato') return [];
        return [
            <tr><th colSpan={2}>Copertura pianificata</th></tr>,
            <tr><td  style={{fontWeight: '500', color: '#5f6a6a'}}>Data</td><td>{data['PIANIFICAZIONE_BITSTREAM_NGA_VULA_FTTCab']}</td></tr>,
        ]
    }

    const displayDetails = (name, id, tag) => {

        let upSpeed, downSpeed, distance, state;

        upSpeed = data["VELOCITA_UP"+id];
        downSpeed = data["VELOCITA_DOWN"+id]
        distance = data["DISTANZA_BITSTREAM_NGA_VULA_FTTCab"]
        state = data["COPERTURA"+id]

        if(state !== 'Attivo' && state !== 'SI' && state !== 'Pianificato') return;

        let screen = (
            <div style={{backgroundColor: 'white', minHeight: '150px', paddingBottom: '10px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <h1 style={{color: '#ff0f64'}}>{name}</h1>
                    <img onClick={() => setTechnologies(defTech)} src={Close} style={{cursor: 'pointer', width: "50px", height: '50px'}} alt="" />
                </div>
                <table width='100%'>
                    <tbody className="detailTable">
                            {
                                tag === 'R' && [setPrevDate(state), [
                                    <tr><th colSpan={2}>Generali</th></tr>,
                                    <tr><td style={{fontWeight: '500', color: '#5f6a6a'}}>Distanza armadio</td><td>{distance}{(distance !== "N.D.") ? "m" : ""}</td></tr>,
                                    <tr><th colSpan={2}>Velocità massime stimate</th></tr>,
                                    <tr><td  style={{fontWeight: '500', color: '#5f6a6a'}}>Download</td><td>{downSpeed+" Mb/s"}</td></tr>,
                                    <tr><td  style={{fontWeight: '500', color: '#5f6a6a'}}>Upload</td><td>{upSpeed+" Mb/s"}</td></tr>,
                                ]]
                            }
                            {
                                name === 'FTTH' && [
                                    <tr><th colSpan={2}>Bande disponibili</th></tr>,
                                    <tr><td style={{fontWeight: '500', color: '#5f6a6a'}}>1Gbit/s</td><td><img src={setIcon(state)} alt="" style={{width: '30px', height: '30px', margin: 'auto'}}/></td></tr>,
                                    <tr><td style={{fontWeight: '500', color: '#5f6a6a'}}>2.5Gbit/s</td><td><img src={setIcon(state)} alt="" style={{width: '30px', height: '30px', margin: 'auto'}}/></td></tr>,
                                    <tr><td style={{fontWeight: '500', color: '#5f6a6a'}}>10Gbit/s</td><td><img src={setIcon(data["COPERTURA_BITSTREAM_NGA_VULA_XGSPON"])} alt="" style={{width: '30px', height: '30px', margin: 'auto'}}/></td></tr>
                                ]
                            }
                            {
                                tag === 'FD' && [
                                    <tr><td style={{fontWeight: '500', color: '#5f6a6a', width: '50%', height: '35px'}}>Fascia</td><td><span style={{backgroundColor: '#ff0f64', color: 'white', fontWeight: "500", padding: '3px', paddingLeft: '6px', paddingRight: '6px', borderRadius: '5px', margin: 'auto'}}>{data["FASCIA_CIRCUITI_TERM_ETH_FIBRA_OTTICA"]}</span></td></tr>,
                                    <tr><td  style={{border: '0', textAlign: 'left'}} colSpan={2}>
                                        <p style={{marginBottom: "8px"}}>La fibra ottica dedicata offre una connessione Internet ad altissima velocità, affidabilità e stabilità.</p>
                                        <p>La soluzione è riservata alla clientela Top Business.</p>
                                    </td></tr>
                                ]
                            }
                    </tbody>
                </table>
            </div>
        )

        setTechnologies(screen)

    }

    return(
        <>
            {technologies}
        </>
    )
}

export default DetailSection;